import classNames from 'classnames'
import styles from './AddUserModal.module.css'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch } from '../../../redux/store'
import {
  fetchEditUser,
  setIsVisibleModalUser,
} from '../../../redux/reducers/users'
import { usersSelector } from '../../../redux/selectors/users-selector'
// import { getRole } from '../../../utils/getRole'
import ModalImage from 'react-modal-image'
import { useClearBodyNoScrollClass } from '../../../hooks/use-clear-body-no-scroll-slass'
import { convertFileIfHeic } from '../../../utils/heicUtils'
import { toast } from 'react-toastify'
import { clientsSelector } from '../../../redux/selectors/clients-selector'
import { fetchClients } from '../../../redux/reducers/clients'
import { default as Select } from 'react-select'
import { getHost } from '../../../utils/getHost'

// const { isAdmin, isOwner } = getRole()

interface ClientOption {
  value: number
  label: string
}

const roles = [
  { role: 'Водитель', value: 'driver' },
  { role: 'Админ', value: 'admin' },
  { role: 'Владелец', value: 'owner' },
  { role: 'Клиент', value: 'client' },
]

const MainInfo = ({
  photo,
  setPhoto,
  selectedImage,
  setSelectedImage,
  login,
  setLogin,
  isActive,
  setIsActive,
  name,
  setName,
  role,
  setRole,
  email,
  setEmail,
  phone2,
  setPhone2,
  phone,
  setPhone,
  password,
  setPassword,
  confirmPassword,
  setConfirmPassword,
  errors,
  setErrors,
  id,
  selectedClient,
  setSelectedClient,
  clients,
}: any) => {
  // const dispatch = useDispatch<AppDispatch>()

  const handleImageChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e?.target?.files?.[0]
    if (!file) return
    try {
      const converted = await convertFileIfHeic(file)
      setSelectedImage(converted)
      setPhoto(URL.createObjectURL(converted))
    } catch {
      toast.error(
        'HEIC не поддерживается в этом браузере. Сохраните фото в JPG и загрузите снова.'
      )
    }
  }

  const handleInputChange =
    (setter: React.Dispatch<React.SetStateAction<string>>, field: string) =>
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setter(e.target.value)
      //@ts-ignore
      setErrors((prevErrors) => ({
        ...prevErrors,
        [field]: !!e.target.value ? false : true,
      }))
    }

  return (
    <>
      <div className="row">
        <div className="col-12 col-sm-6 col-md-6 col-lg-6 mb-3">
          <div className={styles.loadPhoto}>
            <div
              className={`${styles.colorBlue} ${styles.loadPhotoInputWrapper}`}
            >
              <div className={`${styles.profileAvatar} mb-1`}>
                <ModalImage
                  className={`${styles.profileAvatar} mb-1`}
                  small={photo || 'img/users/no-avatar.png'}
                  alt="User Photo"
                />
              </div>

              <span className={styles.small}>Загрузить фото</span>

              <input
                type="file"
                name="photo"
                onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                  handleImageChange(event)
                }
              />
            </div>
          </div>
        </div>

        <div className="col-12 col-sm-6 col-md-6 col-lg-6 mb-3">
          <small className={classNames('mb-1', 'd-block', styles.small2)}>
            Логин
          </small>

          <input
            value={login}
            onChange={handleInputChange(setLogin, 'login')}
            required
            type="text"
            placeholder="Логин"
            className={errors.login ? styles.isError : ''}
          />

          <div className={classNames('mt-3', styles.small)}>
            <input
              checked={isActive}
              type="checkbox"
              onChange={(e) => {
                setIsActive(e.target.checked)
              }}
              id="user_access"
              name="user_access"
              className={styles.input}
            />

            <label htmlFor="user_access">Доступ активен</label>
          </div>
        </div>

        <div className="col-12 col-sm-6 col-md-6 col-lg-6 mb-3">
          <small className={classNames('mb-1', 'd-block', styles.small2)}>
            Имя
          </small>

          <input
            onChange={handleInputChange(setName, 'name')}
            value={name}
            required
            type="text"
            name="name"
            placeholder="Имя"
            className={errors.name ? styles.isError : ''}
          />
        </div>

        <div className="col-12 col-sm-6 col-md-6 col-lg-6 mb-3">
          <small className={classNames('mb-1', 'd-block', styles.small2)}>
            Статус
          </small>
          <select
            value={role}
            onChange={(e) => {
              setRole(e.target.value)
              //@ts-ignore
              setErrors((prevErrors) => ({ ...prevErrors, role: false }))
            }}
            required
            className={classNames('mb-2', errors.role ? styles.isError : '')}
          >
            <option value={undefined}>Выберите роль</option>
            {roles.map((item) => {
              const { role, value } = item
              return <option value={value}>{role}</option>
            })}
          </select>
        </div>

        {role === 'client' && (
          <div className="col-12 col-sm-12 col-md-12 col-lg-12 mb-3">
            <small className={classNames('mb-1', 'd-block', styles.small2)}>
              Клиент
            </small>
            <Select<ClientOption>
              options={[
                { value: 0, label: 'Клиент не выбран' },
                ...clients
                  .map((client: any) => ({
                    value: client.id,
                    label: client.entity_name || client.name || 'Без имени',
                  }))
                  .sort((a: any, b: any) => a.label.localeCompare(b.label)),
              ]}
              value={selectedClient}
              onChange={(selectedOption) => {
                setSelectedClient(selectedOption)
              }}
              placeholder="Выберите клиента"
              noOptionsMessage={() => 'Клиент не найден'}
              isSearchable
              styles={{
                control: (base, { isFocused }) => ({
                  ...base,
                  minHeight: '38px',
                  height: '38px',
                  boxShadow: isFocused
                    ? 'inset 1px 3px 5px 0px #0000001c;'
                    : 'inset 1px 3px 5px 0px #0000001c;',
                  backgroundColor: '#fff',
                  borderRadius: '5px',
                  fontSize: '16px',
                  fontWeight: 400,
                  color: '#012140',
                  transition: 'all 0.3s ease',
                  border: 'none',
                  outline: 'none',
                  '&:hover': {
                    border: 'none',
                    outline: 'none',
                  },
                  '&:focus': {
                    border: 'none',
                    outline: 'none',
                    boxShadow: 'inset 1px 3px 5px 0px #0000001c;',
                  },
                  '&:active': {
                    border: 'none',
                    outline: 'none',
                  },
                }),
                valueContainer: (base) => ({
                  ...base,
                  height: '40px',
                  padding: '0 15px',
                }),
                input: (base) => ({
                  ...base,
                  margin: '0px',
                  padding: '0px',
                  color: '#012140',
                  '& input': {
                    height: '38px',
                    boxShadow: 'none !important',
                    border: 'none !important',
                  },
                }),
                indicatorsContainer: (base) => ({
                  ...base,
                  height: '38px',
                }),
                dropdownIndicator: (base, { isFocused }) => ({
                  ...base,
                  padding: '4px',
                  color: isFocused ? '#0a4475' : '#012140',
                  transition: 'color 0.3s ease',
                }),
                option: (base, { isFocused, isSelected }) => ({
                  ...base,
                  backgroundColor: isSelected ? '#0a4475' : 'white',
                  color: isSelected
                    ? 'white'
                    : isFocused
                      ? '#b60e27'
                      : '#012140',
                  padding: '8px 15px',
                  fontSize: '16px',
                  borderBottom: '1px solid #e0e0e0',
                  '&:last-child': {
                    borderBottom: 'none',
                  },
                  '&:active': {
                    backgroundColor: '#0a4475',
                    color: 'white',
                  },
                  '&:hover': {
                    color: '#b60e27',
                    backgroundColor: 'white',
                  },
                }),
                menu: (base) => ({
                  ...base,
                  marginTop: '5px',
                  boxShadow: '0 4px 10px rgba(0, 0, 0, 0.3)',
                  borderRadius: '5px',
                  overflow: 'hidden',
                }),
                singleValue: (base, { isDisabled }) => ({
                  ...base,
                  color: isDisabled ? '#69697a' : '#012140',
                  transition: 'color 0.3s ease',
                }),
                placeholder: (base, { isDisabled }) => ({
                  ...base,
                  color: isDisabled ? '#69697a' : '#69697a',
                  transition: 'color 0.3s ease',
                }),
              }}
              components={{
                IndicatorSeparator: () => null,
                DropdownIndicator: (props) => (
                  <div
                    {...props.innerProps}
                    style={{
                      padding: '4px',
                      marginRight: '10px',
                    }}
                  >
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 14 4"
                      fill="currentColor"
                      style={{
                        transition:
                          'transform 0.2s ease, margin-bottom 0.2s ease',
                        transform: props.selectProps.menuIsOpen
                          ? 'rotate(180deg)'
                          : 'rotate(0)',
                        marginBottom: props.selectProps.menuIsOpen
                          ? '-4px'
                          : '0',
                      }}
                    >
                      <path d="M0.636,0.293C0.824,0.105,1.078,0,1.343,0S1.862,0.105,2.05,0.293L7,5.243L11.95,0.293c0.189-0.182,0.441-0.283,0.703-0.281c0.262,0.002,0.513,0.107,0.698,0.293c0.391,0.391,0.391,1.025,0,1.416l-5.657,5.657c-0.188,0.188-0.442,0.293-0.707,0.293s-0.519-0.105-0.707-0.293L0.636,1.709C0.247,1.318,0.247,0.684,0.636,0.293z" />
                    </svg>
                  </div>
                ),
              }}
            />
          </div>
        )}

        <div className="col-12 col-sm-6 col-md-6 col-lg-6 mb-3">
          <small className={classNames('mb-1', 'd-block', styles.small2)}>
            E-mail
          </small>
          <input
            onChange={(e) => {
              setEmail(e.target.value)
            }}
            value={email}
            type="email"
            name="name"
            placeholder="E-mail"
          />
        </div>

        <div className="col-12 col-sm-6 col-md-6 col-lg-6 mb-3">
          <small className={classNames('mb-1', 'd-block', styles.small2)}>
            Телефоны (с кодом страны)
          </small>

          <input
            onChange={(e) => {
              setPhone(e.target.value)
            }}
            className="mb-1"
            value={phone || ''}
            type="text"
            name="name"
            placeholder="Телефон RUS"
          />

          <input
            onChange={(e) => {
              setPhone2(e.target.value)
            }}
            className="mb-1"
            value={phone2 || ''}
            type="text"
            name="name"
            placeholder="Телефон BY"
          />
        </div>
        <div className="col-12 mb-3">
          <b>Сменить пароль</b>
        </div>

        <div className="col-12 col-sm-6 col-md-6 col-lg-6 mb-3">
          <small className={classNames('mb-1', 'd-block', styles.small2)}>
            Новый пароль
          </small>
          <input
            onChange={handleInputChange(setPassword, 'password')}
            value={password}
            required={!id}
            type="password"
            name="password"
            placeholder="Новый пароль"
            className={errors.password ? styles.isError : ''}
          />
        </div>

        <div className="col-12 col-sm-6 col-md-6 col-lg-6 mb-3">
          <small className={classNames('mb-1', 'd-block', styles.small2)}>
            Повторите пароль
          </small>
          <input
            onChange={handleInputChange(setConfirmPassword, 'confirmPassword')}
            value={confirmPassword}
            required={!id}
            type="password"
            name="confirmPassword"
            placeholder="Повторите пароль"
            className={errors.confirmPassword ? styles.isError : ''}
          />
        </div>
      </div>
    </>
  )
}

const License = ({
  driversCardNumber,
  setDriversCardNumber,
  driversCardIssueDate,
  setDriversCardIssueDate,
  driversCardIssueAuthority,
  setDriversCardIssueAuthority,
  driversCardExpirationDate,
  setDriversCardExpirationDate,
  driversLicensedNumber,
  setDriversLicensedNumber,
  driversLicensedIssueDate,
  setDriversLicensedIssueDate,
  driversLicensedIssueAuthority,
  setDriversLicensedIssueAuthority,
  driversLicensedExpirationDate,
  setDriversLicensedExpirationDate,
}: any) => {
  return (
    <div className="tab-content" data-content="tab_profile_drive">
      <div className="mb-2">
        <b>Водительское удостоверение</b>
      </div>

      {/* <div class="row mb-5">
				
						
								<div class="col-12 col-sm-5 col-md-5 col-lg-5 mb-3">
									<small class="small-2 d-block mb-1">Срок действия</small>
									<div class="calendar" id="calendar_drive_card2_date"><input class="calendar-input date-input" value="" required type="text"  id="drive_card2_date" placeholder="Срок действия"></div>
								</div>
								<div class="col-12 mb-3">
									<small class="small-2 d-block mb-1">Кем выдано</small>
									<input required type="text" placeholder="Кем выдано">
								</div>
							</div> */}
      <div className="row mb-5">
        <div className="col-12 col-sm-3 col-md-3 col-lg-3 mb-3">
          <small className={classNames('mb-1', 'd-block', styles.small2)}>
            Номер
          </small>
          <input
            onChange={(e) => {
              setDriversLicensedNumber(e.target.value)
            }}
            value={driversLicensedNumber}
            type="text"
            name="name"
            placeholder="Номер"
          />
        </div>
        <div className="col-12 col-sm-4 col-md-4 col-lg-4 mb-3">
          <small className={classNames('mb-1', 'd-block', styles.small2)}>
            Дата выдачи
          </small>
          <div className={styles.calendar}>
            <input
              className={classNames(styles.calendarInput, styles.date)}
              value={driversLicensedIssueDate}
              type="date"
              id="pass_date"
              // placeholder="Дата выдачи"
              onChange={(e) => setDriversLicensedIssueDate(e.target.value)}
              pattern="\d{4}-\d{2}-\d{2}"
            />
          </div>
        </div>

        <div className="col-12 col-sm-5 col-md-5 col-lg-5 mb-3">
          <small className={classNames('mb-1', 'd-block', styles.small2)}>
            Срок действия
          </small>
          <div className={styles.calendar}>
            <input
              className={classNames(styles.calendarInput, styles.date)}
              value={driversLicensedExpirationDate}
              type="date"
              id="pass_date"
              // placeholder="Дата выдачи"
              onChange={(e) => setDriversLicensedExpirationDate(e.target.value)}
              pattern="\d{4}-\d{2}-\d{2}"
            />
          </div>
        </div>

        <div className="col-12 mb-3">
          <small className={classNames('mb-1', 'd-block', styles.small2)}>
            Кем выдано
          </small>

          <input
            onChange={(e) => {
              setDriversLicensedIssueAuthority(e.target.value)
            }}
            value={driversLicensedIssueAuthority}
            type="text"
            name="name"
            placeholder="Кем выдано"
          />
        </div>
      </div>

      <div className="mb-2">
        <b>Карта водителя</b>
      </div>
      <div className="row">
        <div className="col-12 col-sm-3 col-md-3 col-lg-3 mb-3">
          <small className={classNames('mb-1', 'd-block', styles.small2)}>
            Номер
          </small>

          <input
            onChange={(e) => {
              setDriversCardNumber(e.target.value)
            }}
            value={driversCardNumber}
            type="text"
            name="name"
            placeholder="Номер"
          />
        </div>
        <div className="col-12 col-sm-4 col-md-4 col-lg-4 mb-3">
          <small className={classNames('mb-1', 'd-block', styles.small2)}>
            Дата выдачи
          </small>
          <div className={styles.calendar}>
            <input
              className={classNames(styles.calendarInput, styles.date)}
              value={driversCardIssueDate}
              type="date"
              id="pass_date"
              // placeholder="Дата выдачи"
              onChange={(e) => setDriversCardIssueDate(e.target.value)}
              pattern="\d{4}-\d{2}-\d{2}"
            />
          </div>
        </div>

        <div className="col-12 col-sm-5 col-md-5 col-lg-5 mb-3">
          <small className={classNames('mb-1', 'd-block', styles.small2)}>
            Срок действия
          </small>
          <div className={styles.calendar}>
            <input
              className={classNames(styles.calendarInput, styles.date)}
              value={driversCardExpirationDate}
              type="date"
              id="pass_date"
              // placeholder="Дата выдачи"
              onChange={(e) => setDriversCardExpirationDate(e.target.value)}
              pattern="\d{4}-\d{2}-\d{2}"
            />
          </div>
        </div>

        <div className="col-12 mb-3">
          <small className={classNames('mb-1', 'd-block', styles.small2)}>
            Кем выдано
          </small>
          <input
            onChange={(e) => {
              setDriversCardIssueAuthority(e.target.value)
            }}
            value={driversCardIssueAuthority}
            type="text"
            name="name"
            placeholder="Кем выдано"
          />
        </div>
      </div>
    </div>
  )
}

const Passport = ({
  passportSerial,
  setPassportSerial,
  passportNumber,
  setPassportNumber,
  passportDate,
  setPassportDate,
  passportIssue,
  setPassportIssue,
  passportRegistration,
  setPassportRegistration,
  birthDate,
  setBirthDate,
  expirationDate,
  setExpirationDate,
}: any) => {
  return (
    <div className="row">
      {/* <div class="tab-content" data-content="tab_profile_pass">	
							<div class="row">


				
								<div class="col-12 col-sm-4 col-md-4 col-lg-4 mb-3">
									<small class="small-2 d-block mb-1">Срок действия</small>
									<div class="calendar" id="calendar_pass_date_2"><input class="calendar-input date-input" value="" required type="text" id="pass_date_2" placeholder="Срок действия"></div>
								</div>
								
							</div>
						</div> */}

      <div className="col-12 col-sm-4 col-md-4 col-lg-4 mb-3">
        <small className={classNames('mb-1', 'd-block', styles.small2)}>
          Серия и номер
        </small>
        <input
          value={passportSerial}
          onChange={(e) => setPassportSerial(e.target.value)}
          type="text"
          placeholder="Серия и номер паспорта"
        />
      </div>
      <div className="col-12 col-sm-4 col-md-4 col-lg-4 mb-3">
        <small className={classNames('mb-1', 'd-block', styles.small2)}>
          Идентиф. номер
        </small>
        <input
          value={passportNumber}
          onChange={(e) => setPassportNumber(e.target.value)}
          type="text"
          placeholder="Идентификационный номер"
        />
      </div>

      <div className="col-12 col-sm-4 col-md-4 col-lg-4 mb-3">
        <small className={classNames('mb-1', 'd-block', styles.small2)}>
          Дата рождения
        </small>
        <div className={styles.calendar}>
          <input
            className={classNames(styles.calendarInput, styles.date)}
            value={birthDate}
            type="date"
            id="pass_date"
            // placeholder="Дата выдачи"
            onChange={(e) => setBirthDate(e.target.value)}
            pattern="\d{4}-\d{2}-\d{2}"
          />
        </div>
      </div>
      <div className="col-12 col-sm-4 col-md-4 col-lg-4 mb-3">
        <small className={classNames('mb-1', 'd-block', styles.small2)}>
          Дата выдачи
        </small>
        <div className={styles.calendar}>
          <input
            className={classNames(styles.calendarInput, styles.date)}
            value={passportDate}
            type="date"
            id="pass_date"
            // placeholder="Дата выдачи"
            onChange={(e) => setPassportDate(e.target.value)}
            pattern="\d{4}-\d{2}-\d{2}"
          />
        </div>
      </div>
      <div className="col-12 col-sm-8 col-md-8 col-lg-8 mb-3">
        <small className={classNames('mb-1', 'd-block', styles.small2)}>
          Кем выдан
        </small>
        <input
          value={passportIssue}
          onChange={(e) => setPassportIssue(e.target.value)}
          type="text"
          placeholder="Кем выдан"
        />
      </div>

      {/* <div class="col-12 col-sm-4 col-md-4 col-lg-4 mb-3">
									<small class="small-2 d-block mb-1">Срок действия</small>
									<div class="calendar" id="calendar_pass_date_2"><input class="calendar-input date-input" value="" required type="text" id="pass_date_2" placeholder="Срок действия"></div>
								</div> */}
      <div className="col-12 col-sm-4 col-md-4 col-lg-4 mb-3">
        <small className={classNames('mb-1', 'd-block', styles.small2)}>
          Срок действия
        </small>
        <div className={styles.calendar}>
          <input
            className={classNames(styles.calendarInput, styles.date)}
            value={expirationDate}
            type="date"
            id="pass_date"
            // placeholder="Дата выдачи"
            onChange={(e) => setExpirationDate(e.target.value)}
            pattern="\d{4}-\d{2}-\d{2}"
          />
        </div>
      </div>

      <div className="col-12 col-sm-8 col-md-8 col-lg-8 mb-3">
        <small className={classNames('mb-1', 'd-block', styles.small2)}>
          Прописка
        </small>
        <input
          value={passportRegistration}
          onChange={(e) => setPassportRegistration(e.target.value)}
          type="text"
          placeholder="Прописка"
        />
      </div>
    </div>
  )
}

function AddUserModal() {
  const dispatch = useDispatch<AppDispatch>()
  const { currentUserByRequest } = useSelector(usersSelector)
  const { clients } = useSelector(clientsSelector)
  useClearBodyNoScrollClass()

  useEffect(() => {
    dispatch(fetchClients())
  }, [dispatch])

  // MAIN INFO
  const [photo, setPhoto] = useState<null | string>(null)
  const [selectedImage, setSelectedImage] = useState<any>(null)
  const [login, setLogin] = useState('')
  const [isActive, setIsActive] = useState(
    currentUserByRequest?.active || false
  )
  const [name, setName] = useState('')
  const [role, setRole] = useState('')
  const [email, setEmail] = useState('')
  const [phone, setPhone] = useState('')
  const [phone2, setPhone2] = useState('')
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [selectedClient, setSelectedClient] = useState<ClientOption | null>(
    null
  )

  // License

  const [driversCardNumber, setDriversCardNumber] = useState('')
  const [driversCardIssueDate, setDriversCardIssueDate] = useState('')
  const [driversCardIssueAuthority, setDriversCardIssueAuthority] = useState('')
  const [driversCardExpirationDate, setDriversCardExpirationDate] = useState('')

  const [driversLicensedNumber, setDriversLicensedNumber] = useState('')
  const [driversLicensedIssueDate, setDriversLicensedIssueDate] = useState('')
  const [driversLicensedIssueAuthority, setDriversLicensedIssueAuthority] =
    useState('')
  const [driversLicensedExpirationDate, setDriversLicensedExpirationDate] =
    useState('')

  // Passport
  const [passportSerial, setPassportSerial] = useState('')
  const [passportNumber, setPassportNumber] = useState('')
  const [passportDate, setPassportDate] = useState('')
  const [passportIssue, setPassportIssue] = useState('')
  const [passportRegistration, setPassportRegistration] = useState('')
  const [birthDate, setBirthDate] = useState('')
  const [expirationDate, setExpirationDate] = useState('')

  const [errors, setErrors] = useState({
    login: false,
    name: false,
    role: false,
    password: false,
    confirmPassword: false,
  })

  const checkValidation = () => {
    const newErrors = {
      login: !login,
      name: !name,
      role: !role,
      password: !currentUserByRequest?.id && !password,
      confirmPassword: !currentUserByRequest?.id && !confirmPassword,
    }

    setErrors(newErrors)
  }

  useEffect(() => {
    if (currentUserByRequest) {
      // const {} = currentUserByRequest

      // setIsActive(active);
      setPhoto(currentUserByRequest?.avatar?.md)
    }
  }, [currentUserByRequest])

  const [currentTab, setCurrentTab] = useState(1)

  useEffect(() => {
    if (role === 'client' && (currentTab === 2 || currentTab === 3)) {
      setCurrentTab(1)
    }
  }, [role, currentTab])

  useEffect(() => {
    if (role !== 'client' && selectedClient) {
      setSelectedClient(null)
    }
  }, [role, selectedClient])

  // const [isDisabledButton, setIsDisabledButton] = useState(true)

  useEffect(() => {
    if (currentUserByRequest) {
      const {
        name,
        active,
        login = '',
        phone,
        phone2,
        registration,
        email,
        role,
        avatar,
        passport,
        drivers_license,
        drivers_card,
      } = currentUserByRequest
      setName(name)
      setIsActive(active)
      setLogin(login)
      setPhone(phone)
      setPhone2(phone2)
      setPassportRegistration(registration)
      setEmail(email)
      setRole(role)
      setPhoto(avatar.sm)

      //passport

      setPassportSerial(passport?.identification_number)
      setPassportNumber(passport?.number)
      setPassportDate(passport?.issue_date)
      setPassportIssue(passport?.issue_authority)
      setBirthDate(passport?.birth_date)
      setExpirationDate(passport?.expiration_date)

      setDriversCardNumber(drivers_card?.number)
      setDriversCardIssueDate(drivers_card?.issue_date)
      setDriversCardIssueAuthority(drivers_card?.issue_authority)
      setDriversCardExpirationDate(drivers_card?.expiration_date)

      setDriversLicensedNumber(drivers_license?.number)
      setDriversLicensedIssueDate(drivers_license?.issue_date)
      setDriversLicensedIssueAuthority(drivers_license?.issue_authority)
      setDriversLicensedExpirationDate(drivers_license?.expiration_date)

      // Инициализируем выбранного клиента если роль - client
      if (role === 'client' && currentUserByRequest?.client) {
        const client = currentUserByRequest.client
        setSelectedClient({
          value: client.id,
          label: client.entity_name || client.name,
        })
      }
    }
  }, [currentUserByRequest])

  const handleSaveUser = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()

    const commonPayload = {
      photo,
      selectedImage,
      login,
      isActive,
      name,
      role,
      email,
      phone,
      phone2,
      password,
      confirmPassword,
      client_id: selectedClient?.value || null,
      driversCardNumber,
      driversCardIssueDate,
      driversCardIssueAuthority,
      driversCardExpirationDate,
      driversLicensedNumber,
      driversLicensedIssueDate,
      driversLicensedIssueAuthority,
      driversLicensedExpirationDate,
      passportSerial,
      passportNumber,
      passportDate,
      passportIssue,
      passportRegistration,
      birthDate,
      expirationDate,
    }

    const newErrors = {
      password: !currentUserByRequest?.id && !password,
      confirmPassword: !currentUserByRequest?.id && !confirmPassword,
      login: !login,
      name: !name,
      role: !role,
    }

    setErrors(newErrors)

    const hasErrors = Object.values(newErrors).some((error) => error)

    if (!hasErrors) {
      dispatch(
        fetchEditUser({
          ...commonPayload,
          id: currentUserByRequest?.id,
        })
      )
    }
  }

  // const handleSaveCar = (e: React.FormEvent<HTMLFormElement>) => {
  //   e.preventDefault()

  // }

  // useEffect(() => {
  //   const isNewUser = !currentUserByRequest?.id
  //   const isValidNewUser =
  //     login &&
  //     role &&
  //     role !== 'Select a role' &&
  //     name &&
  //     password &&
  //     confirmPassword === password
  //   const isValidPassword = confirmPassword === password && password !== ''

  //   const isActiveWasChanged = isActive === currentUserByRequest?.active

  //   const isUnchangedExistingUser =
  //     (!name || name === currentUserByRequest?.name) &&
  //     email === currentUserByRequest?.email &&
  //     (!login || login === currentUserByRequest?.login) &&
  //     role === currentUserByRequest?.role &&
  //     !isValidPassword &&
  //     isActiveWasChanged
  //   const areRequiredFieldsFilled =
  //     name !== '' && login !== '' && confirmPassword === password

  //   setIsDisabledButton(
  //     (isNewUser ? !isValidNewUser : isUnchangedExistingUser) ||
  //       !areRequiredFieldsFilled
  //   )
  // }, [
  //   confirmPassword,
  //   currentUserByRequest,
  //   email,
  //   name,
  //   password,
  //   role,
  //   login,
  //   isActive,
  // ])

  const renderComponent = () => {
    const mainInfoProps = {
      photo,
      setPhoto,
      selectedImage,
      setSelectedImage,
      login,
      setLogin,
      isActive,
      setIsActive,
      name,
      setName,
      role,
      setRole,
      email,
      setEmail,
      phone2,
      setPhone2,
      phone,
      setPhone,
      password,
      setPassword,
      confirmPassword,
      setConfirmPassword,
      errors,
      setErrors,
      id: currentUserByRequest?.id,
      selectedClient,
      setSelectedClient,
      clients,
    }

    const licenseProps = {
      driversCardNumber,
      setDriversCardNumber,
      driversCardIssueDate,
      setDriversCardIssueDate,
      driversCardIssueAuthority,
      setDriversCardIssueAuthority,
      driversCardExpirationDate,
      setDriversCardExpirationDate,
      driversLicensedNumber,
      setDriversLicensedNumber,
      driversLicensedIssueDate,
      setDriversLicensedIssueDate,
      driversLicensedIssueAuthority,
      setDriversLicensedIssueAuthority,
      driversLicensedExpirationDate,
      setDriversLicensedExpirationDate,
    }

    const passportProps = {
      passportSerial,
      setPassportSerial,
      passportNumber,
      setPassportNumber,
      passportDate,
      setPassportDate,
      passportIssue,
      setPassportIssue,
      passportRegistration,
      setPassportRegistration,
      birthDate,
      setBirthDate,
      expirationDate,
      setExpirationDate,
    }
    switch (currentTab) {
      case 1:
        return <MainInfo {...mainInfoProps} />

      case 2:
        if (role === 'client') {
          return <MainInfo {...mainInfoProps} />
        }
        return <License {...licenseProps} />

      case 3:
        if (role === 'client') {
          return <MainInfo {...mainInfoProps} />
        }
        return <Passport {...passportProps} />

      default:
        return <MainInfo {...mainInfoProps} />
    }
  }

  return (
    <div style={{ display: 'block' }} className={styles.win}>
      <div className={styles.winContainer}>
        <div className={styles.winContent}>
          <div
            onClick={() => dispatch(setIsVisibleModalUser(false))}
            className={styles.close}
          >
            ×
          </div>
          <div className={styles.winContentFulltext}>
            <h3
              style={{ textAlign: 'center' }}
              className={classNames(role === 'driver' ? 'mb-3' : 'mb-5', styles.h3)}
            >
              {currentUserByRequest
                ? currentUserByRequest.name
                : 'Новый сотрудник'}
            </h3>
            {(role === 'driver' || role === 'admin' || role === 'owner') && currentUserByRequest?.user_pdf_driver_card_url && (
              <div className="mb-3" style={{ textAlign: 'center' }}>
                <a
                  href={`${getHost()}${currentUserByRequest?.user_pdf_driver_card_url}`}
                  target="_blank"
                  rel="noreferrer"
                  className={classNames(
                    styles.btn,
                    styles.btnSmall2,
                    styles.btnBlueOutline
                  )}
                >
                  <i
                    className={classNames(styles.icon, styles.iconDownload)}
                  />{' '}
                  Карточка PDF
                </a>
              </div>
            )}
            <div
              className={classNames('row align-items-end', styles.radioTabs)}
            >
              <div
                className={classNames(
                  styles.menuButton,
                  currentTab === 1 ? styles.menuButtonActive : '',
                  'col-4 col-sm-4 col-md-4 mt-2'
                )}
                onClick={() => setCurrentTab(1)}
              >
                Основное
              </div>
              {role !== 'client' && (
                <div
                  className={classNames(
                    styles.menuButton,
                    currentTab === 2 ? styles.menuButtonActive : '',
                    'col-4 col-sm-4 col-md-4 mt-2'
                  )}
                  onClick={() => setCurrentTab(2)}
                >
                  Права и карта
                </div>
              )}
              {role !== 'client' && (
                <div
                  className={classNames(
                    styles.menuButton,
                    currentTab === 3 ? styles.menuButtonActive : '',
                    'col-4 col-sm-4 col-md-4 mt-2'
                  )}
                  onClick={() => setCurrentTab(3)}
                >
                  Паспорт
                </div>
              )}
            </div>
            <form onSubmit={handleSaveUser}>
              {renderComponent()}
              <div className="row mt-3">
                <div
                  className="col-12 col-sm-6 mt-1 mb-1"
                  style={{ textAlign: 'left' }}
                >
                  <button
                    onClick={checkValidation}
                    className={classNames(
                      'd-block',
                      'd-sm-inline-block',
                      styles.btn
                    )}
                    // disabled={isDisabledButton}
                  >
                    <i className={`${styles.icon} ${styles.iconCheckWhite}`} />{' '}
                    Сохранить
                  </button>
                </div>
                <div
                  className="col-12 col-sm-6 mt-1 mb-1"
                  style={{ textAlign: 'right' }}
                >
                  <div
                    onClick={() => dispatch(setIsVisibleModalUser(false))}
                    className={classNames(
                      'd-block',
                      'd-sm-inline-block',
                      styles.btn,
                      styles.btnSmall,
                      styles.btnBlueOutline
                    )}
                  >
                    Отмена
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AddUserModal
